import React, { useState, useEffect, useCallback } from 'react';

function App() {
  const [activePage, setActivePage] = useState(
    localStorage.getItem('userRole') === 'izvajalec' ? 'iskanje' : 'zaposleni'
  );
  const [podizvajalci, setPodizvajalci] = useState([]);
  const [naziv, setNaziv] = useState('');
  const [kontakt, setKontakt] = useState('');
  const [lokacija, setLokacija] = useState('');
  const [myPodizvajalecId, setMyPodizvajalecId] = useState('');

  const [selectedPodizvajalecId, setSelectedPodizvajalecId] = useState('');
  const [zaposleni, setZaposleni] = useState([]);
  const [ime, setIme] = useState('');
  const [storitev, setStoritev] = useState('');
  const [ocena, setOcena] = useState(5);
  const [editingZaposleniId, setEditingZaposleniId] = useState(null);

  const [searchTerm, setSearchTerm] = useState('');
  const [searchLocation, setSearchLocation] = useState('');
  const [selectedSearchPodizvajalecId, setSelectedSearchPodizvajalecId] = useState('');
  const [searchEmployees, setSearchEmployees] = useState([]);
  const [loadingSearchEmployees, setLoadingSearchEmployees] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token') || '');
  const [username, setUsername] = useState(localStorage.getItem('username') || '');
  const [userRole, setUserRole] = useState(localStorage.getItem('userRole') || '');
  const [registrationRole, setRegistrationRole] = useState('');
  const [password, setPassword] = useState('');
  const [authError, setAuthError] = useState(null);
  const [authMode, setAuthMode] = useState('login');

  const handleExpiredSession = useCallback(() => {
    setToken('');
    setUsername('');
    setUserRole('');
    setMyPodizvajalecId('');
    setSelectedPodizvajalecId('');
    setSelectedSearchPodizvajalecId('');
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('userRole');
    setAuthMode('login');
    setAuthError('Vaša seja je potekla. Za nadaljevanje se ponovno prijavite.');
  }, []);

  const authFetch = useCallback((url, options = {}) => {
    return fetch(url, {
      ...options,
      headers: { ...options.headers, Authorization: `Bearer ${token}` },
    }).then(res => {
      if (res.status === 401) {
        handleExpiredSession();
        throw new Error('Vaša seja je potekla.');
      }
      return res;
    });
  }, [token, handleExpiredSession]);

  useEffect(() => {
    if (!token || userRole !== 'izvajalec') {
      setPodizvajalci([]);
      return;
    }
    const params = new URLSearchParams();
    if (searchTerm.trim()) params.set('storitev', searchTerm.trim());
    const query = params.toString();
    authFetch(`http://localhost:3001/podizvajalci${query ? `?${query}` : ''}`)
      .then(res => {
        if (!res.ok) throw new Error('Napaka pri pridobivanju podatkov');
        return res.json();
      })
      .then(data => {
        setPodizvajalci(data);
      })
      .catch(err => setError(err.message));
  }, [token, userRole, searchTerm, authFetch]);

  // When token is present, load current podizvajalec data (editable only by them)
  useEffect(() => {
    if (!token) {
      setMyPodizvajalecId('');
      return;
    }

    const profileEndpoint = userRole === 'izvajalec' ? 'izvajalci' : 'podizvajalci';
    authFetch(`http://localhost:3001/${profileEndpoint}/me`)
      .then(res => {
        if (!res.ok) throw new Error('Napaka pri pridobivanju podatkov o podizvajalcu');
        return res.json();
      })
      .then(data => {
        setNaziv(data.naziv || '');
        setKontakt(data.kontakt || '');
        setLokacija(data.lokacija || '');
        setMyPodizvajalecId(userRole === 'podizvajalec' && data.id ? data.id.toString() : '');
      })
      .catch(err => {
        // don't block the app if this fails; clear local edit state
        setError(err.message);
        setMyPodizvajalecId('');
      });
  }, [token, userRole, authFetch]);

  useEffect(() => {
    if (userRole === 'podizvajalec' && podizvajalci.length > 0 && !selectedPodizvajalecId) {
      setSelectedPodizvajalecId(podizvajalci[0].id.toString());
    }
  }, [podizvajalci, selectedPodizvajalecId, userRole]);

  // If the logged-in podizvajalec is known, select it so their employees are shown
  useEffect(() => {
    if (myPodizvajalecId) {
      setSelectedPodizvajalecId(myPodizvajalecId);
    }
  }, [myPodizvajalecId]);

  useEffect(() => {
    if (userRole !== 'podizvajalec' || !selectedPodizvajalecId) {
      setZaposleni([]);
      return;
    }

    authFetch(`http://localhost:3001/zaposleni/${selectedPodizvajalecId}`)
      .then(res => {
        if (!res.ok) throw new Error('Napaka pri pridobivanju zaposlenih');
        return res.json();
      })
      .then(data => {
        setZaposleni(data);
      })
      .catch(err => setError(err.message));
  }, [selectedPodizvajalecId, token, userRole, authFetch]);

  useEffect(() => {
    if (userRole !== 'izvajalec' || !selectedSearchPodizvajalecId) {
      setSearchEmployees([]);
      return;
    }

    setLoadingSearchEmployees(true);
    authFetch(`http://localhost:3001/zaposleni/${selectedSearchPodizvajalecId}`)
      .then(res => {
        if (!res.ok) throw new Error('Napaka pri pridobivanju zaposlenih');
        return res.json();
      })
      .then(data => setSearchEmployees(data))
      .catch(err => setError(err.message))
      .finally(() => setLoadingSearchEmployees(false));
  }, [selectedSearchPodizvajalecId, token, userRole, authFetch]);

  const dodajPodizvajalca = (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    authFetch('http://localhost:3001/podizvajalci', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ naziv, kontakt, lokacija }),
    })
      .then(res => {
        setLoading(false);
        if (!res.ok) throw new Error('Napaka pri dodajanju podizvajalca');
        return res.json();
      })
      .then(() => {
        // backend updates the current podizvajalec; refresh list and keep selection
        setNaziv(naziv);
        setKontakt(kontakt);
        setLokacija(lokacija);
        return authFetch('http://localhost:3001/podizvajalci');
      })
      .then(res => {
        if (!res.ok) throw new Error('Napaka pri osvežitvi podizvajalcev');
        return res.json();
      })
      .then(data => {
        setPodizvajalci(data);
        // ensure selected podizvajalec remains the user's one if available
        if (myPodizvajalecId) {
          setSelectedPodizvajalecId(myPodizvajalecId);
        } else if (data.length > 0 && !selectedPodizvajalecId) {
          setSelectedPodizvajalecId(data[0].id.toString());
        }
      })
      .catch(err => setError(err.message));
  };

  const posodobiIzvajalca = (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    authFetch('http://localhost:3001/izvajalci', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ naziv, kontakt, lokacija }),
    })
      .then(res => {
        if (!res.ok) throw new Error('Napaka pri posodabljanju izvajalca');
        return res.json();
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  };

  const dodajZaposlenega = (e) => {
    e.preventDefault();
    if (!selectedPodizvajalecId) return;

    setLoading(true);
    setError(null);

    const method = editingZaposleniId ? 'PUT' : 'POST';
    const url = editingZaposleniId 
      ? `http://localhost:3001/zaposleni/${editingZaposleniId}`
      : 'http://localhost:3001/zaposleni';

    const body = editingZaposleniId 
      ? JSON.stringify({
          ime,
          storitev,
          ocena: Number(ocena),
        })
      : JSON.stringify({
          podizvajalec_id: selectedPodizvajalecId,
          ime,
          storitev,
          ocena: Number(ocena),
        });

    authFetch(url, {
      method,
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body,
    })
      .then(res => {
        setLoading(false);
        if (!res.ok) {
          return res.json()
            .then(err => { throw new Error(err.error || 'Napaka pri shranjevanju zaposlenega'); })
            .catch(() => { throw new Error('Napaka pri shranjevanju zaposlenega'); });
        }
        return res.json();
      })
      .then(() => {
        setIme('');
        setStoritev('');
        setOcena(5);
        setEditingZaposleniId(null);
        return authFetch(`http://localhost:3001/zaposleni/${selectedPodizvajalecId}`);
      })
      .then(res => {
        if (!res.ok) throw new Error('Napaka pri osvežitvi zaposlenih');
        return res.json();
      })
      .then(data => {
        setZaposleni(data);
      })
      .catch(err => setError(err.message));
  };

  const urediZaposlenega = (zaposleni) => {
    setIme(zaposleni.ime);
    setStoritev(zaposleni.storitev);
    setOcena(zaposleni.ocena != null ? Number(zaposleni.ocena) : 5);
    setEditingZaposleniId(zaposleni.id.toString());
  };

  const izbrisiZaposlenega = () => {
    if (!editingZaposleniId || !window.confirm('Ali ste prepričani, da želite izbrisati zaposlenega?')) return;

    setLoading(true);
    setError(null);

    authFetch(`http://localhost:3001/zaposleni/${editingZaposleniId}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => {
        setLoading(false);
        if (!res.ok) throw new Error('Napaka pri brisanju zaposlenega');
        return res.json();
      })
      .then(() => {
        setIme('');
        setStoritev('');
        setOcena(5);
        setEditingZaposleniId(null);
        return authFetch(`http://localhost:3001/zaposleni/${selectedPodizvajalecId}`);
      })
      .then(res => {
        if (!res.ok) throw new Error('Napaka pri osvežitvi zaposlenih');
        return res.json();
      })
      .then(data => setZaposleni(data))
      .catch(err => setError(err.message));
  };

  const prekliciUrejanje = () => {
    setIme('');
    setStoritev('');
    setOcena(5);
    setEditingZaposleniId(null);
  };

  const handleAuthSubmit = async (e) => {
    e.preventDefault();
    setAuthError(null);
    setError(null);

    const endpoint = authMode === 'login' ? 'login' : 'register';
    try {
      const res = await fetch(`http://localhost:3001/${endpoint}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: username, password, role: registrationRole }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || `Napaka pri ${authMode}`);

      setToken(data.token);
      setUserRole(data.role);
      localStorage.setItem('token', data.token);
      localStorage.setItem('username', username);
      localStorage.setItem('userRole', data.role);
      setActivePage(data.role === 'izvajalec' ? 'iskanje' : 'zaposleni');
      setPassword('');
      setAuthError(null);
    } catch (err) {
      setAuthError(err.message);
    }
  };

  const handleLogout = () => {
    setToken('');
    setUsername('');
    setUserRole('');
    setSelectedPodizvajalecId('');
    setSelectedSearchPodizvajalecId('');
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('userRole');
  };

  const renderStars = (rating) => {
    const count = Math.round(Number(rating) || 0);
    const filled = '★'.repeat(Math.min(Math.max(count, 0), 5));
    const empty = '☆'.repeat(5 - Math.min(Math.max(count, 0), 5));
    return filled + empty;
  };

  const filteredPodizvajalci = podizvajalci.filter(podizvajalec => {
    const locationQuery = searchLocation.trim().toLowerCase();
    const matchesLocation = !locationQuery || (podizvajalec.lokacija || '')
      .toLowerCase()
      .includes(locationQuery);
    return matchesLocation;
  });

  return (
    <div style={{ maxWidth: 800, margin: 'auto', padding: 20 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16, marginBottom: 28, padding: '32px 28px', borderRadius: 12, color: 'white', backgroundImage: "linear-gradient(90deg, rgba(12, 31, 45, 0.9) 0%, rgba(12, 31, 45, 0.72) 52%, rgba(12, 31, 45, 0.35) 100%), url('/banner.png')", backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 'clamp(2rem, 6vw, 3.25rem)', letterSpacing: '-0.04em' }}>Projektpartner</h1>
          <p style={{ margin: '8px 0 0', maxWidth: 440, fontSize: '1.05rem', lineHeight: 1.5 }}>Povezujemo izvajalce z zaupanja vrednimi podizvajalci in njihovimi ekipami.</p>
        </div>
        {token && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <button type="button" onClick={() => setActivePage('profile')} title="Moji podatki" style={{ fontSize: 18 }}>🧑‍💼</button>
            <button type="button" onClick={() => setActivePage('profile')} style={{ border: 'none', background: 'none', padding: 0, fontSize: 14, color: 'white', cursor: 'pointer', textDecoration: 'underline' }}>
              {username}
            </button>
            <button type="button" onClick={handleLogout}>Odjava</button>
          </div>
        )}
      </div>

      {!token ? (
        <section style={{ marginBottom: 20, padding: 15, border: '1px solid #ddd', borderRadius: 6, background: '#fafafa' }}>
          <h2>{authMode === 'login' ? 'Prijava' : 'Registracija'}</h2>
          {authError && <p style={{ color: 'red' }}>{authError}</p>}
          <form onSubmit={handleAuthSubmit} style={{ display: 'grid', gap: 10 }}>
            {authMode === 'register' && (
              <div>
                <label>Registriram se kot:</label><br />
                <select value={registrationRole} onChange={e => setRegistrationRole(e.target.value)} required style={{ width: '100%' }}>
                  <option value="" disabled>Izberi vlogo</option>
                  <option value="podizvajalec">Podizvajalec</option>
                  <option value="izvajalec">Izvajalec</option>
                </select>
              </div>
            )}
            <div>
              <label>Email:</label><br />
              <input
                type="email"
                value={username}
                onChange={e => setUsername(e.target.value)}
                required
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <label>Geslo:</label><br />
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                style={{ width: '100%' }}
              />
            </div>
            <button type="submit">{authMode === 'login' ? 'Prijava' : 'Registracija'}</button>
          </form>
          <div style={{ marginTop: 15 }}>
            <button type="button" onClick={() => setAuthMode(authMode === 'login' ? 'register' : 'login')} style={{ border: 'none', background: 'none', padding: 0, color: '#46637a', fontSize: '0.9rem', cursor: 'pointer', textDecoration: 'underline' }}>
              {authMode === 'login' ? 'Še nimate računa? Registrirajte se.' : 'Že imate račun? Na prijavo'}
            </button>
          </div>
        </section>
      ) : (
        <></>
      )}

      {error && <p style={{ color: 'red' }}>{error}</p>}

      {token ? (
        activePage === 'profile' ? (
          userRole === 'izvajalec' ? (
            <form onSubmit={posodobiIzvajalca} style={{ marginBottom: 30 }}>
              <button type="button" onClick={() => setActivePage('iskanje')} style={{ marginBottom: 20 }}>Nazaj na iskanje</button>
              <h2>Podatki izvajalca</h2>
              <div style={{ marginBottom: 10 }}><label>Naziv:</label><br /><input type="text" value={naziv} onChange={e => setNaziv(e.target.value)} required style={{ width: '100%' }} /></div>
              <div style={{ marginBottom: 10 }}><label>Kontakt:</label><br /><input type="text" value={kontakt} onChange={e => setKontakt(e.target.value)} style={{ width: '100%' }} /></div>
              <div style={{ marginBottom: 10 }}><label>Lokacija:</label><br /><input type="text" value={lokacija} onChange={e => setLokacija(e.target.value)} style={{ width: '100%' }} /></div>
              <button type="submit" disabled={loading}>{loading ? 'Posodabljanje...' : 'Posodobi podatke'}</button>
            </form>
          ) : (
          <>
            <button type="button" onClick={() => setActivePage('zaposleni')} style={{ marginBottom: 20, padding: '8px 14px', borderRadius: 4, border: '1px solid #ccc', background: '#f7f7f7', cursor: 'pointer' }}>
              ← Domov
            </button>
            <form onSubmit={dodajPodizvajalca} style={{ marginBottom: 30 }}>
              <h2>Vaši podatki</h2>
              <div style={{ marginBottom: 10 }}>
                <label>Naziv:</label><br />
                <input type="text" value={naziv} onChange={e => setNaziv(e.target.value)} required style={{ width: '100%' }} />
              </div>
              <div style={{ marginBottom: 10 }}>
                <label>Kontakt:</label><br />
                <input type="text" value={kontakt} onChange={e => setKontakt(e.target.value)} style={{ width: '100%' }} />
              </div>
              <div style={{ marginBottom: 10 }}>
                <label>Lokacija:</label><br />
                <input type="text" value={lokacija} onChange={e => setLokacija(e.target.value)} style={{ width: '100%' }} />
              </div>
              <button type="submit" disabled={loading}>{loading ? 'Posodabljanje...' : 'Posodobi podatke'}</button>
            </form>

            {/* Seznam podizvajalcev je odstranjen z te strani; uporablja se ločeno stran za iskanje. */}
          </>
          )
        ) : activePage === 'iskanje' ? (
          <section>
            <div style={{ marginBottom: 24 }}>
              <h2>Iščem podizvajalca</h2>
              <p>Poiščite izvajalca po nazivu, dejavnosti oziroma lokaciji in preverite njegovo ekipo.</p>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 12, padding: 15, border: '1px solid #ddd', borderRadius: 6, background: '#f9f9f9' }}>
                <div>
                  <label htmlFor="search-term">Dejavnost</label><br />
                  <input id="search-term" type="search" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} placeholder="npr. elektrika" style={{ width: '100%', boxSizing: 'border-box' }} />
                </div>
                <div>
                  <label htmlFor="search-location">Lokacija</label><br />
                  <input id="search-location" type="search" value={searchLocation} onChange={e => setSearchLocation(e.target.value)} placeholder="npr. Ljubljana" style={{ width: '100%', boxSizing: 'border-box' }} />
                </div>
              </div>
            </div>

            {filteredPodizvajalci.length === 0 ? <p>Za izbrane pogoje ni najdenih podizvajalcev.</p> : (
              <div style={{ display: 'grid', gap: 12 }}>
                {filteredPodizvajalci.map(p => {
                  const isSelected = p.id.toString() === selectedSearchPodizvajalecId;
                  return (
                    <article key={p.id} style={{ padding: 16, border: `1px solid ${isSelected ? '#2e7d32' : '#ddd'}`, borderRadius: 6, background: isSelected ? '#f1f8f2' : '#fff' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, alignItems: 'flex-start' }}>
                        <div>
                          <h3 style={{ margin: '0 0 8px' }}>{p.naziv || 'Podizvajalec brez naziva'}</h3>
                          {p.lokacija && <p style={{ margin: '4px 0' }}>Lokacija: {p.lokacija}</p>}
                          {p.kontakt && <p style={{ margin: '4px 0' }}>Kontakt: {p.kontakt}</p>}
                        </div>
                        <button type="button" onClick={() => setSelectedSearchPodizvajalecId(isSelected ? '' : p.id.toString())}>
                          {isSelected ? 'Skrij ekipo' : 'Poglej ekipo'}
                        </button>
                      </div>
                      {isSelected && (
                        <div style={{ marginTop: 14, paddingTop: 12, borderTop: '1px solid #cfe4d1' }}>
                          <strong>Ekipa</strong>
                          {loadingSearchEmployees ? <p>Nalaganje zaposlenih ...</p> : searchEmployees.length === 0 ? <p>Podizvajalec še nima vpisanih zaposlenih.</p> : (
                            <ul style={{ paddingLeft: 20, marginBottom: 0 }}>
                              {searchEmployees.map(z => <li key={z.id}>{z.ime} — {z.storitev} ({renderStars(z.ocena)} {Number(z.ocena).toFixed(1)})</li>)}
                            </ul>
                          )}
                        </div>
                      )}
                    </article>
                  );
                })}
              </div>
            )}
          </section>
        ) : (
          <>
            <section style={{ marginBottom: 30 }}>
              <h2>Vaši zaposleni</h2>

              <form onSubmit={dodajZaposlenega} style={{ marginBottom: 20, padding: 15, border: '1px solid #ddd', borderRadius: 6, background: '#f9f9f9' }}>
                <h3>{editingZaposleniId ? 'Uredi zaposlenega' : 'Dodaj zaposlenega'}</h3>
                {myPodizvajalecId ? (
                  <div style={{ marginBottom: 10 }}>
                    <label>Podizvajalec:</label><br />
                    <input type="text" value={(podizvajalci.find(p => p.id.toString() === myPodizvajalecId) || {}).naziv || ''} disabled style={{ width: '100%' }} />
                  </div>
                ) : (
                  <div style={{ marginBottom: 10 }}>
                    <label>Izberi podizvajalca:</label><br />
                    <select
                      value={selectedPodizvajalecId}
                      onChange={e => setSelectedPodizvajalecId(e.target.value)}
                      required
                      disabled={editingZaposleniId !== null}
                      style={{ width: '100%' }}
                    >
                      <option value="">Izberi podizvajalca</option>
                      {podizvajalci.map(p => (
                        <option key={p.id} value={p.id}>{p.naziv}</option>
                      ))}
                    </select>
                  </div>
                )}

                <div style={{ marginBottom: 10 }}>
                  <label>Ime zaposlenega:</label><br />
                  <input type="text" value={ime} onChange={e => setIme(e.target.value)} required style={{ width: '100%' }} />
                </div>
                <div style={{ marginBottom: 10 }}>
                  <label>Storitve zaposlenega:</label><br />
                  <input type="text" value={storitev} onChange={e => setStoritev(e.target.value)} required style={{ width: '100%' }} />
                </div>
                <div style={{ marginBottom: 10 }}>
                  <label>Ocena (1-5):</label><br />
                  <select value={ocena} onChange={e => setOcena(e.target.value)} style={{ width: '100%' }}>
                    {[1, 2, 3, 4, 5].map(n => (
                      <option key={n} value={n}>{n}</option>
                    ))}
                  </select>
                </div>

                <div style={{ display: 'flex', gap: 10 }}>
                  <button type="submit" disabled={loading || !selectedPodizvajalecId}>
                    {loading ? 'Shranjujem...' : (editingZaposleniId ? 'Posodobi zaposlenega' : 'Dodaj zaposlenega')}
                  </button>
                  {editingZaposleniId && (
                    <>
                      <button type="button" onClick={prekliciUrejanje} disabled={loading} style={{ background: '#f0f0f0' }}>
                        Prekliči
                      </button>
                      <button type="button" onClick={izbrisiZaposlenega} disabled={loading} style={{ background: '#ff6b6b', color: 'white' }}>
                        Izbriši
                      </button>
                    </>
                  )}
                </div>
              </form>

              <h3>Seznam zaposlenih</h3>
              {!selectedPodizvajalecId ? (
                <p>Izberi podizvajalca, da prikažeš zaposlene.</p>
              ) : zaposleni.length === 0 ? (
                <p>Trenutno ni zaposlenih za izbranega podizvajalca.</p>
              ) : (
                <ul style={{ listStyle: 'none', padding: 0 }}>
                  {zaposleni.map(z => (
                    <li key={z.id} style={{ marginBottom: 15, padding: 12, border: '1px solid #ddd', borderRadius: 4, background: editingZaposleniId === z.id.toString() ? '#e8f5e9' : '#fff' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <div style={{ flex: 1 }}>
                          <strong>{z.ime}</strong> ({z.storitev})<br />
                          Ocena: {z.ocena ? renderStars(z.ocena) : 'Še ni ocene'} {z.ocena ? `(${Number(z.ocena).toFixed(1)})` : ''}
                        </div>
                        <button
                          type="button"
                          onClick={() => urediZaposlenega(z)}
                          style={{ background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', padding: '5px 10px' }}
                          title="Uredi zaposlenega"
                        >
                          ✏️
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </section>
          </>
        )
      ) : (
        authMode === 'login' && <p>Prijavite se, da lahko uporabljate aplikacijo.</p>
      )}
    </div>
  );
}

export default App;
